import React from "react"
import {
	Text,
	View,
	Image,
	StyleSheet,
	Svg,
	Path,
	Defs,
	LinearGradient,
	RadialGradient,
	Stop,
} from "@react-pdf/renderer"
import { CalendarRangeIconPDF } from "./icons/CalendarRange"
import { DollarSignIconPDF } from "./icons/DollarSign"

const styles = StyleSheet.create({
	header: {
		flexDirection: "row",
		justifyContent: "space-between",
		alignItems: "center",
		paddingHorizontal: 16,
		paddingVertical: 10,
		borderRadius: 8,
		backgroundColor: "white",
		border: "1px solid #dadada",
	},
	headerTitle: {
		fontFamily: "Roboto",
		fontSize: 20,
		marginBottom: 8,
		fontWeight: "bold",
	},
	headerRow: {
		flexDirection: "row",
		gap: 32,
	},
	headerItem: {
		flexDirection: "row",
		alignItems: "center",
		gap: 12,
	},
	headerItemLabel: {
		fontSize: 10,
		color: "black",
		marginBottom: 2,
		fontWeight: "bold",
	},
	headerItemValue: {
		fontSize: 10,
		fontWeight: "normal",
		color: "black",
	},
	headerIconWrapper: {
		padding: 8,
		backgroundColor: "#F1F5F9",
		borderRadius: 12,
	},
})

interface ReportHeaderProps {
	dateRange: string
	businessRate: string
}

export const ReportHeaderPDF: React.FC<ReportHeaderProps> = ({
	dateRange,
	businessRate,
}) => {
	return (
		<View style={styles.header}>
			<View>
				<Text style={styles.headerTitle}>Mileage Report</Text>
				<View style={styles.headerRow}>
					<View style={styles.headerItem}>
						<View style={styles.headerIconWrapper}>
							<CalendarRangeIconPDF />
						</View>
						<View>
							<Text style={styles.headerItemLabel}>Report date range</Text>
							<Text style={styles.headerItemValue}>{dateRange}</Text>
						</View>
					</View>
					<View style={styles.headerItem}>
						<View style={styles.headerIconWrapper}>
							<DollarSignIconPDF stroke="#020617" width={24} height={24} />
						</View>
						<View>
							<Text style={styles.headerItemLabel}>Business Rate</Text>
							<Text style={styles.headerItemValue}>{businessRate}</Text>
						</View>
					</View>
				</View>
			</View>
			<View style={{ marginTop: "-48px", marginRight: "0px" }}>
				<LogoLandSVG />
			</View>
		</View>
	)
}

const LogoLandSVG: React.FC = () => {
	return (
		<Svg width="186" height="28" viewBox="0 0 100 42">
			<Path
				d="M0.0740232 13.559L0.163702 28.6482C0.174126 30.4021 1.11927 32.0178 2.6442 32.8857L15.7576 40.3533C17.2812 41.2212 19.1535 41.2101 20.6667 40.3241L33.6904 32.7012C35.2036 31.8152 36.1308 30.1884 36.1204 28.4345L36.0307 13.3453C36.0203 11.5914 35.0751 9.97576 33.5502 9.10783L20.4368 1.64026C18.9132 0.77232 17.0409 0.783448 15.5277 1.66943L2.50398 9.29235C0.989475 10.1783 0.0635992 11.8051 0.0740232 13.559Z"
				fill="url('#paint0_linear_3059_8469')"
			/>
			<Path
				d="M18.2021 38.6577C17.3603 38.6627 16.5185 38.4517 15.7652 38.0229L4.64411 31.6898C3.13876 30.8322 2.19625 29.223 2.18596 27.4912L2.1099 14.6933C2.0996 12.9602 3.02161 11.34 4.51797 10.4658L15.563 4.00098C17.058 3.12551 18.9225 3.11443 20.4279 3.97207L31.5489 10.3052C33.0543 11.1628 33.9968 12.7719 34.0071 14.5037L34.0831 27.3016C34.0934 29.0347 33.1714 30.6537 31.6751 31.5292L20.6301 37.994C19.8832 38.4304 19.044 38.6527 18.2021 38.6577ZM17.9988 4.44322C17.3899 4.44684 16.7806 4.6079 16.2386 4.9247L4.99258 11.5065C3.90857 12.1401 3.24023 13.3139 3.24769 14.5694L3.32514 27.6003C3.3326 28.8558 4.01484 30.0215 5.10631 30.6422L16.4297 37.0899C17.5212 37.7106 18.8718 37.7026 19.9545 37.069L31.2004 30.4871C32.2845 29.8535 32.9528 28.6785 32.9453 27.4242L32.8679 14.3934C32.8604 13.1378 32.1782 11.9721 31.0867 11.3514L19.7633 4.90375C19.2189 4.59341 18.6077 4.4396 17.9988 4.44322Z"
				fill="white"
			/>
			<Path
				d="M24.3879 29.5961L28.7032 27.0709C28.7512 27.0433 28.7808 26.991 28.7805 26.9351L28.7096 15.0076C28.7093 14.9517 28.679 14.9011 28.6307 14.8728L24.1551 12.3244C24.0938 12.2896 24.0171 12.3005 23.9666 12.3502L18.1877 18.1982C18.1269 18.2597 18.0281 18.2603 17.9678 18.1995L12.1199 12.4206C12.0701 12.3715 11.992 12.3615 11.931 12.397L7.48607 14.9985C7.43809 15.0261 7.40848 15.0783 7.40881 15.1342L7.4797 27.063C7.48004 27.1189 7.51026 27.1695 7.55858 27.1978L11.9036 29.6716C12.008 29.7308 12.1377 29.6546 12.137 29.5349L12.076 19.2768C12.0752 19.1375 12.2426 19.0676 12.3408 19.1646L14.8159 21.6104L18.0069 24.7637C18.0684 24.8245 18.1673 24.8239 18.2267 24.7624L21.38 21.5714L23.8259 19.0963C23.9229 18.9982 24.0911 19.0661 24.0919 19.2053L24.1529 29.4621C24.1549 29.5818 24.2842 29.6565 24.3879 29.5961Z"
				fill="white"
			/>
			<Path
				d="M18.8128 31.7956L17.5039 31.8033L17.5195 34.4264L18.8284 34.4186L18.8128 31.7956Z"
				fill="#FDE848"
			/>
			<Path
				d="M18.7875 27.2792L17.4785 27.287L17.4941 29.9101L18.803 29.9023L18.7875 27.2792Z"
				fill="#FDE848"
			/>
			<Path
				d="M18.6957 12.0847L17.3867 12.0925L17.4023 14.7155L18.7112 14.7078L18.6957 12.0847Z"
				fill="#FDE848"
			/>
			<Path
				d="M18.6683 7.56719L17.3594 7.57497L17.375 10.198L18.6839 10.1903L18.6683 7.56719Z"
				fill="#FDE848"
			/>
			<Path
				d="M182.544 28.4953L182.448 12.348L185.827 12.3279L185.923 28.4752L182.544 28.4953Z"
				fill="url(#paint1_radial_3059_8469)"
			/>
			<Path
				d="M170.878 12.4168L165.334 28.5976L168.881 28.5765L170.074 24.6527L170.844 22.1191L172.843 15.5384L172.911 15.538L174.989 22.0945L175.789 24.6188L177.028 28.5281L180.575 28.507L174.859 12.4168L170.878 12.4168Z"
				fill="url(#paint2_radial_3059_8469)"
			/>
			<Path
				d="M175.789 24.6188L174.989 22.0945L170.844 22.1191L170.074 24.6527L175.789 24.6188Z"
				fill="url(#paint3_radial_3059_8469)"
			/>
			<Path
				d="M58.01 29.3446L57.9478 18.8781L53.9188 26.6965L52.2487 26.7065L48.1271 18.9365L48.1893 29.403L45.1161 29.4212L45.0222 13.6102L48.318 13.5906L53.048 22.5595L57.7156 13.5347L60.9891 13.5153L61.0831 29.3264L58.01 29.3446Z"
				fill="#2C3148"
			/>
			<Path
				d="M64.0033 29.309L63.9339 17.64L66.918 17.6222L66.9873 29.2913L64.0033 29.309ZM63.9243 16.0143L63.9067 13.0525L66.8907 13.0348L66.9083 15.9966L63.9243 16.0143Z"
				fill="#2C3148"
			/>
			<Path
				d="M69.469 13.0195L72.4531 13.0017L72.5275 25.517C72.53 25.9475 72.6997 26.7136 72.8563 27.0962C73.0522 27.5746 73.3826 28.097 73.974 28.693C74.4116 29.1341 74.6081 29.2304 74.6331 29.3446C74.6779 29.5502 73.221 29.5589 72.5515 29.5628C71.6162 29.5684 70.842 29.2015 70.3195 28.7147C69.8117 28.2129 69.5551 27.5018 69.5496 26.5814L69.469 13.0195Z"
				fill="#2C3148"
			/>
			<Path
				d="M80.8237 29.4317C79.8884 29.4373 79.0413 29.2864 78.2823 28.9792C77.5232 28.6571 76.8748 28.2229 76.337 27.6768C75.7993 27.1307 75.3798 26.4948 75.0786 25.7691C74.7922 25.0433 74.6466 24.2795 74.6418 23.4779C74.6369 22.6465 74.7733 21.8662 75.0511 21.1371C75.3287 20.3931 75.7331 19.7449 76.2643 19.1924C76.7954 18.6251 77.4386 18.1758 78.1938 17.8447C78.9639 17.5135 79.824 17.3451 80.7741 17.3395C81.7243 17.3338 82.5715 17.4921 83.3157 17.8143C84.0748 18.1364 84.7158 18.5706 85.2387 19.1168C85.7764 19.6629 86.181 20.2989 86.4526 21.0248C86.739 21.7506 86.8845 22.5069 86.8892 23.2937C86.8903 23.4867 86.884 23.6723 86.8702 23.8506C86.8713 24.0287 86.8573 24.1773 86.8283 24.2962L77.8093 24.3498C77.8566 24.8098 77.9704 25.2174 78.1507 25.5726C78.3309 25.9279 78.5629 26.2309 78.8464 26.4816C79.13 26.7323 79.4503 26.9234 79.8074 27.0549C80.1645 27.1864 80.5361 27.251 80.9221 27.2487C81.5159 27.2452 82.0718 27.1008 82.5898 26.8157C83.1225 26.5156 83.4839 26.1274 83.6741 25.6512L86.2393 26.3486C85.814 27.2419 85.128 27.9809 84.1813 28.5655C83.2494 29.1352 82.1302 29.424 80.8237 29.4317ZM83.8105 22.3767C83.7311 21.5012 83.4003 20.8054 82.8182 20.2892C82.2509 19.7581 81.559 19.495 80.7424 19.4998C80.3416 19.5022 79.9634 19.5787 79.608 19.7293C79.2673 19.8649 78.9642 20.0597 78.6984 20.3137C78.4327 20.5677 78.2118 20.8733 78.0358 21.2307C77.8746 21.588 77.7804 21.982 77.7533 22.4127L83.8105 22.3767Z"
				fill="#2C3148"
			/>
			<Path
				d="M88.8314 29.1614L88.7376 13.3726L91.8107 13.3544L91.8553 20.8591L98.4468 13.2926L101.832 13.2725L95.8162 20.3233L102.304 29.0814L98.8525 29.1019L93.8904 22.2945L91.8765 24.4221L91.9045 29.1432L88.8314 29.1614Z"
				fill="#2C3148"
			/>
			<Path
				d="M107.596 29.2726C106.661 29.2782 105.814 29.1273 105.055 28.82C104.296 28.4979 103.647 28.0638 103.11 27.5177C102.572 26.9716 102.152 26.3356 101.851 25.61C101.565 24.8842 101.419 24.1204 101.414 23.3187C101.409 22.4874 101.546 21.7071 101.824 20.978C102.101 20.234 102.506 19.5858 103.037 19.0333C103.568 18.4659 104.211 18.0167 104.966 17.6856C105.736 17.3544 106.596 17.186 107.547 17.1803C108.497 17.1747 109.344 17.333 110.088 17.6552C110.847 17.9773 111.488 18.4115 112.011 18.9577C112.549 19.5038 112.954 20.1398 113.225 20.8657C113.511 21.5915 113.657 22.3478 113.662 23.1346C113.663 23.3276 113.657 23.5132 113.643 23.6915C113.644 23.8696 113.63 24.0182 113.601 24.1371L104.582 24.1907C104.629 24.6507 104.743 25.0583 104.923 25.4135C105.103 25.7688 105.335 26.0718 105.619 26.3225C105.903 26.5732 106.223 26.7643 106.58 26.8958C106.937 27.0273 107.309 27.0919 107.695 27.0896C108.288 27.086 108.844 26.9417 109.362 26.6565C109.895 26.3564 110.256 25.9683 110.447 25.4921L113.012 26.1894C112.587 27.0828 111.901 27.8218 110.954 28.4064C110.022 28.9761 108.903 29.2648 107.596 29.2726ZM110.583 22.2176C110.504 21.3421 110.173 20.6463 109.591 20.1301C109.023 19.599 108.331 19.3359 107.515 19.3407C107.114 19.3431 106.736 19.4196 106.381 19.5702C106.04 19.7058 105.737 19.9006 105.471 20.1546C105.205 20.4085 104.984 20.7142 104.808 21.0716C104.647 21.4289 104.553 21.8229 104.526 22.2536L110.583 22.2176Z"
				fill="#2C3148"
			/>
			<Path
				d="M120.836 29.1939C119.901 29.1995 119.053 29.0486 118.294 28.7414C117.535 28.4192 116.887 27.9851 116.349 27.439C115.811 26.8929 115.392 26.257 115.091 25.5313C114.804 24.8055 114.659 24.0417 114.654 23.2401C114.649 22.4087 114.785 21.6284 115.063 20.8993C115.341 20.1553 115.745 19.5071 116.276 18.9546C116.808 18.3873 117.451 17.938 118.206 17.6069C118.976 17.2757 119.836 17.1073 120.786 17.1017C121.736 17.096 122.584 17.2543 123.328 17.5765C124.087 17.8986 124.728 18.3328 125.251 18.879C125.789 19.4251 126.193 20.0611 126.465 20.787C126.751 21.5128 126.897 22.2691 126.901 23.0559C126.902 23.2489 126.896 23.4345 126.882 23.6128C126.883 23.7909 126.869 23.9395 126.84 24.0584L117.821 24.112C117.869 24.572 117.983 24.9796 118.163 25.3348C118.343 25.6901 118.575 25.9931 118.859 26.2438C119.142 26.4945 119.462 26.6856 119.82 26.8171C120.177 26.9486 120.548 27.0132 120.934 27.0109C121.528 27.0074 122.084 26.863 122.602 26.5779C123.135 26.2778 123.496 25.8896 123.686 25.4134L126.251 26.1108C125.826 27.0041 125.14 27.7431 124.193 28.3277C123.262 28.8974 122.142 29.1862 120.836 29.1939ZM123.823 22.1389C123.743 21.2634 123.412 20.5676 122.83 20.0514C122.263 19.5203 121.571 19.2572 120.755 19.262C120.354 19.2644 119.976 19.3409 119.62 19.4915C119.279 19.6271 118.976 19.8219 118.711 20.0759C118.445 20.3299 118.224 20.6355 118.048 20.9929C117.887 21.3502 117.793 21.7442 117.765 22.1749L123.823 22.1389Z"
				fill="#2C3148"
			/>
			<Path
				d="M135.08 29.1093C134.159 29.1147 133.357 28.9191 132.671 28.5223C131.986 28.1107 131.448 27.5571 131.058 26.8616L131.098 33.6537L128.114 33.6715L128.017 17.2591L130.622 17.2436L130.634 19.2478C131.061 18.5624 131.614 18.0246 132.295 17.6345C132.975 17.2296 133.761 17.0245 134.652 17.0192C135.439 17.0146 136.167 17.1736 136.837 17.4962C137.507 17.804 138.081 18.2311 138.559 18.7776C139.053 19.3092 139.435 19.9453 139.707 20.686C139.993 21.4118 140.139 22.183 140.143 22.9995C140.148 23.8457 140.027 24.6407 139.779 25.3845C139.531 26.1283 139.179 26.7763 138.722 27.3283C138.279 27.8803 137.748 28.314 137.126 28.6294C136.504 28.9449 135.822 29.1049 135.08 29.1093ZM134.063 26.5765C134.508 26.5739 134.916 26.475 135.286 26.2798C135.671 26.0845 135.996 25.8227 136.261 25.4945C136.526 25.1663 136.732 24.7865 136.878 24.3551C137.024 23.9237 137.095 23.4779 137.093 23.0176C137.09 22.5277 137.005 22.0754 136.84 21.6607C136.674 21.2311 136.441 20.8613 136.143 20.5513C135.859 20.2412 135.516 19.9983 135.114 19.8225C134.727 19.6467 134.303 19.5601 133.843 19.5628C133.561 19.5645 133.272 19.6182 132.975 19.7239C132.679 19.8147 132.405 19.95 132.154 20.1296C131.902 20.3093 131.674 20.5185 131.467 20.7573C131.276 20.9959 131.129 21.2566 131.026 21.5393L131.043 24.2784C131.314 24.9449 131.725 25.4992 132.277 25.9413C132.829 26.3686 133.424 26.5803 134.063 26.5765Z"
				fill="#2C3148"
			/>
			<Path
				d="M147.521 29.0353C146.586 29.0409 145.739 28.89 144.98 28.5828C144.221 28.2607 143.572 27.8265 143.035 27.2804C142.497 26.7343 142.077 26.0984 141.776 25.3727C141.49 24.6469 141.344 23.8831 141.339 23.0815C141.335 22.2501 141.471 21.4698 141.749 20.7407C142.026 19.9967 142.431 19.3485 142.962 18.796C143.493 18.2287 144.136 17.7794 144.891 17.4483C145.662 17.1171 146.522 16.9487 147.472 16.9431C148.422 16.9374 149.269 17.0957 150.013 17.4179C150.772 17.74 151.413 18.1742 151.936 18.7204C152.474 19.2665 152.879 19.9025 153.15 20.6284C153.437 21.3542 153.582 22.1105 153.587 22.8973C153.588 23.0903 153.582 23.2759 153.568 23.4542C153.569 23.6323 153.555 23.7809 153.526 23.8998L144.507 23.9534C144.554 24.4134 144.668 24.821 144.848 25.1762C145.029 25.5315 145.261 25.8345 145.544 26.0852C145.828 26.3359 146.148 26.527 146.505 26.6585C146.862 26.79 147.234 26.8546 147.62 26.8523C148.214 26.8488 148.769 26.7044 149.287 26.4193C149.82 26.1192 150.182 25.731 150.372 25.2548L152.937 25.9522C152.512 26.8455 151.826 27.5845 150.879 28.1691C149.947 28.7388 148.828 29.0276 147.521 29.0353ZM150.508 21.9803C150.429 21.1048 150.098 20.409 149.516 19.8928C148.949 19.3617 148.257 19.0986 147.44 19.1034C147.039 19.1058 146.661 19.1823 146.306 19.3329C145.965 19.4685 145.662 19.6633 145.396 19.9173C145.13 20.1713 144.909 20.4769 144.733 20.8343C144.572 21.1916 144.478 21.5856 144.451 22.0163L150.508 21.9803Z"
				fill="#2C3148"
			/>
			<Path
				d="M162.242 19.639C161.337 19.6592 159.952 19.8456 159.241 20.1913C158.531 20.5222 158.022 21.0226 157.714 21.6925L157.756 28.7518L154.772 28.7695L154.702 17.1005L157.441 17.0842L157.456 19.5784C157.662 19.1763 157.904 18.8185 158.185 18.5051C158.465 18.1768 158.768 17.8929 159.093 17.6534C159.418 17.414 159.743 17.2339 160.069 17.1132C160.41 16.9775 160.736 16.9088 161.048 16.9069C161.211 16.9059 161.907 16.9018 161.981 16.9014C162.07 16.9008 162.152 16.9078 162.226 16.9222L162.242 19.639Z"
				fill="#2C3148"
			/>
			<Defs>
				<LinearGradient
					id="paint0_linear_3059_8469"
					x1="0.119007"
					y1="21.1038"
					x2="36.0743"
					y2="20.8901"
					// gradientUnits="userSpaceOnUse"
				>
					<Stop stopColor="#262B49" offset="0" />
					<Stop stopColor="#394170" offset="1" />
				</LinearGradient>
				<RadialGradient id="paint1_radial_3059_8469" cx="0" cy="0" fr="1">
					<Stop offset="0.268782" stopColor="#03C7FF" />
					<Stop offset="1" stopColor="#03A1FF" />
				</RadialGradient>
				<RadialGradient id="paint2_radial_3059_8469" cx="0" cy="0" fr="1">
					<Stop offset="0.268782" stopColor="#03C7FF" />
					<Stop offset="1" stopColor="#03A1FF" />
				</RadialGradient>
				<RadialGradient id="paint3_radial_3059_8469" cx="0" cy="0" fr="1">
					<Stop offset="0.268782" stopColor="#03C7FF" />
					<Stop offset="1" stopColor="#03A1FF" />
				</RadialGradient>
			</Defs>
		</Svg>
	)
}
